import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=73515dd3&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=73515dd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73515dd3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73515dd3')) {
      api.createRecord('73515dd3', component.options)
    } else {
      api.reload('73515dd3', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=73515dd3&scoped=true&", function () {
      api.rerender('73515dd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-225Jd7sYaMD7r/JS/comp/DocBox.vue"
export default component.exports